var log = Math.log;
var LOG10E = Math.LOG10E;

// eslint-disable-next-line es/no-math-log10 -- safe
module.exports = Math.log10 || function log10(x) {
  return log(x) * LOG10E;
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/math-log10.js
// module id = 1032
// module chunks = 0